export default __webpack_public_path__ + "static/media/avatar.42a86687.jpg";